import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useEffect, useMemo, useState, } from 'react';
export const ConversationContext = createContext({});
export const ConversationContextProvider = (props) => {
    const [translationLanguageCode, setTranslationLanguageCode] = useState();
    const value = useMemo(() => ({
        translationLanguageCode,
        setTranslationLanguageCode,
    }), [translationLanguageCode]);
    // Resets the translation language code when conversation id changes.
    useEffect(() => setTranslationLanguageCode(undefined), [props.csid]);
    return (_jsx(ConversationContext.Provider, Object.assign({ value: value }, { children: props.children })));
};
